import { render } from "./mainTable.vue?vue&type=template&id=4c951742&scoped=true"
import script from "./mainTable.vue?vue&type=script&lang=js"
export * from "./mainTable.vue?vue&type=script&lang=js"

import "./mainTable.vue?vue&type=style&index=0&id=4c951742&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c951742"]])

export default __exports__